export default {
	"refund.ParameterError": "參數錯誤!",
	"refund.refundTime": "退款時間",
	"refund.growBeans": "成長豆",
	"refund.totalRefund": "退款總額",
	"refund.refundAmount": "退款金額"
}